<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields.textColor"
                @change="e => (fields.textColor = e.target.value)"
              />
              <v-text-field v-model="fields.textColor" label="Text Color" :hide-details="true" />
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['background-section'].color"
                @change="e => (fields['background-section'].color = e.target.value)"
              />
              <v-text-field
                v-model="fields['background-section'].color"
                label="Background Color"
                :hide-details="true"
              />
            </div>
          </v-col>
        </v-row>

        <div class="mb-6 mt-6">
          <label class="label-input">Padding</label>
          <div class="group-item">
            <v-row>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.top" label="Top Padding" />
              </v-col>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Background Image</label>
          <div class="group-item">
            <UploadImage
              @callback="obj => (fields['background-section'].image = obj.imageSrc)"
              :image="{ imageSrc: fields['background-section'].image }"
              :height="`160`"
              :typeUpload="'image'"
              @callbackDelete="() => (fields['background-section'].image = '')"
            />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Container content</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields['container-content'].showStyle" label="Show style" />
              </v-col>
              <v-col cols="12" md="8">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-content'].background"
                    @change="e => (fields['container-content'].background = e.target.value)"
                  />
                  <v-text-field v-model="fields['container-content'].background" label="Container background" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Title Card</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.titleCard" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Review Slider</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field v-model.number="fields.wrapReviews.colPerView" type="number" label="Slides Per View" />
              </v-col>
              <v-col cols="12" md="8" class="d-flex justify-end align-center">
                <v-btn small text color="primary" @click="handleAddReview">
                  <v-icon size="16">mdi-plus</v-icon>
                  <span>Add Review</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields.wrapReviews.listItem" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Review {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveReview(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label class="label-input" style="font-size: 14px !important; margin-bottom: 6px">Image</label>
                    <UploadImage
                      @callback="obj => (item.image = obj.imageSrc)"
                      :image="{ imageSrc: item.image }"
                      :height="`200`"
                      :typeUpload="'image'"
                      @callbackDelete="() => (item.image = '')"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="label-input" style="font-size: 14px !important; margin-bottom: 6px">Stars</label>
                    <v-rating
                      color="warning"
                      background-color="#c1c1c1"
                      empty-icon="mdi-star-outline"
                      full-icon="mdi-star"
                      hover
                      length="5"
                      size="28"
                      :value="clampStars(item.stars)"
                      @input="val => (item.stars = clampStars(val))"
                    />
                  </div>
                  <ckeditor :editor="editor" v-model="item.reviewContent" :config="editorConfig" />
                  <v-text-field v-model="item.reviewName" label="Reviewer Name" class="mt-3" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

export default {
  name: 'ReviewTitanSectionEditor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Review Titan Section',
        enableAnchor: false,
        textColor: '#ffffff',
        padding: { top: true, bottom: true },
        'background-section': { color: '#e6e6e6', image: '' },
        'container-content': { showStyle: false, background: '#ffffff' },
        titleCard: '',
        wrapReviews: {
          colPerView: 4,
          listItem: [],
        },
      },
    };
  },
  mounted() {
    const merged = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
    if (merged.wrapReviews?.listItem?.length) {
      merged.wrapReviews.listItem = merged.wrapReviews.listItem.map(it => ({
        ...it,
        stars: this.clampStars(it.stars),
      }));
    }
    this.fields = merged;
  },
  methods: {
    clampStars(val) {
      const n = Number(val);
      if (!Number.isFinite(n)) return 1;
      return Math.max(1, Math.min(5, Math.round(n)));
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        wrapReviews: {
          ...this.fields.wrapReviews,
          listItem: (this.fields.wrapReviews.listItem || []).map(it => ({
            ...it,
            stars: this.clampStars(it.stars),
          })),
        },
      };
      const updateHtml = updateHtmlFromData.sectionReviewTitan(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddReview() {
      this.fields.wrapReviews.listItem.push({
        image: '',
        stars: 5,
        reviewContent: '<h3></h3><p></p>',
        reviewName: '',
      });
    },
    handleRemoveReview(index) {
      this.fields.wrapReviews.listItem.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
